import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, Trash2 } from "lucide-react";
import { PageHero, Section } from "../components/PageKit";
import api, { formatApiErrorDetail } from "../lib/api";
import { usePageMeta } from "../lib/seo";

// One-click story removal from the emailed link (no login).
export default function TestimonialRemove() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  usePageMeta("Remove my story | Dutsen Kauna Foundation", "Take your beneficiary testimonial off the website.");
  useEffect(() => { api.get(`/impact-testimonials/remove/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo(false)); }, [token]);
  const remove = async () => {
    setBusy(true);
    try { await api.post(`/impact-testimonials/remove/${token}`); setDone(true); toast.success("Your story has been removed."); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="testimonial-remove-page">
      <PageHero kicker="Your story, your choice" title="Remove my story" text="You can take your testimonial off our website at any time. No questions asked." />
      <Section>
        <div className="max-w-xl mx-auto bg-white rounded-2xl border border-black/5 p-8 text-center">
          {info === null && <p className="text-sm">Checking your link…</p>}
          {info === false && <p className="text-sm text-red-700" data-testid="remove-invalid">This removal link is not valid. If you need help, email foundation@dutsenkauna.org.</p>}
          {info && (done || info.already_removed) && <div data-testid="remove-done"><ShieldCheck size={40} className="mx-auto text-green-700" /><h2 className="font-serif text-2xl font-bold mt-3">Story removed</h2><p className="text-sm mt-2">{info.serial} is no longer shown on our website. Thank you for having shared it with us.</p><Link to="/testimonials" className="dk-btn-outline !text-[#0d1724] !border-[#0d1724] mt-5">Back to testimonials</Link></div>}
          {info && !done && !info.already_removed && (
            <div>
              <p className="text-sm">You are about to remove the story by <b>{info.full_name}</b> ({info.serial}):</p>
              <blockquote className="text-sm italic bg-[#f8f4e8] rounded-xl p-4 mt-3">“{info.excerpt}…”</blockquote>
              <button onClick={remove} disabled={busy} className="dk-btn-primary mt-6" data-testid="remove-confirm"><Trash2 size={16} /> {busy ? "Removing…" : "Yes, remove my story now"}</button>
              <p className="text-xs text-[#0a0d12]/60 mt-3">Photos and videos stay in our private records until you also ask for them to be deleted — just reply to the confirmation email.</p>
            </div>)}
        </div>
      </Section>
    </div>
  );
}
